import styled from 'styled-components';

const InnerContainer = styled.div`
    display: flex;
    height: auto;
    position: absolute;
    width: 100%;
    z-index: 1;
`;

export default InnerContainer;
